import type ar from './locales/ar'

export type MessageSchema = typeof ar
export type Locale = 'ar' | 'en'

export const SUPPORTED_LOCALES: Locale[] = ['ar', 'en']
export const DEFAULT_LOCALE: Locale =
  ((import.meta.env.VITE_DEFAULT_LOCALE as Locale) ?? 'ar')

export const LOCALE_DIRECTION: Record<Locale, 'rtl' | 'ltr'> = {
  ar: 'rtl',
  en: 'ltr',
}

export const LOCALE_LABEL: Record<Locale, string> = {
  ar: 'العربية',
  en: 'English',
}

export const LOCALE_STORAGE_KEY = 'shopsze-admin:locale'
